import { Alert, Text } from "@/atoms"
import { DisconnectOutlined } from "@/icons"
import { Protected } from "@/molecules/Protected"
import {
  ConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import {
  FormSlack,
  TestSlackButton
} from "@/pages/IntegrationsPage/components/molecules/FormSlack"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { useSlackAPI } from "@/pages/IntegrationsPage/hooks/useSlackAPI"
import { INTEGRATIONS_WRITE_PERMISSION } from "@/pages/IntegrationsPage/IntegrationsPage.constants"

import styles from "./SlackConfigurationPage.module.scss"

import type { SlackConfigurationItemProps } from "."

export const SlackConfigurationItem = (props: SlackConfigurationItemProps) => {
  const { channel, vendor } = props
  const [_, { onRemove, ...actions }] = useIntegration({ vendor })
  const slackApi = useSlackAPI({ channel, ...actions })
  const { id, name, maskedUrl, health } = channel
  const showHealth = !!health && health.status !== "healthy" && !!health.message

  return (
    <ConfigItem
      values={{ id, name, health }}
      Description={maskedUrl && <Text type="secondary">{maskedUrl}</Text>}
    >
      <div className={styles.body}>
        {showHealth && (
          <Alert
            showIcon
            type={health.status === "unhealthy" ? "error" : "warning"}
            title={health.message}
          />
        )}
        <FormSlack
          formId={slackApi.formId}
          channel={channel}
          onFinish={slackApi.onFinish}
          {...actions}
        />
      </div>
      <FooterConfigItem
        formId={slackApi.formId}
        isDirty={actions.isDirty}
        isPending={slackApi.isPending || actions.isPending}
        isTesting={slackApi.isTesting}
        permissions={INTEGRATIONS_WRITE_PERMISSION}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove({ id, name })}
        onReset={actions.onReset}
      >
        <Protected shouldDisable permission={INTEGRATIONS_WRITE_PERMISSION}>
          <TestSlackButton
            size="small"
            form={actions.form}
            t={actions.t}
            channel={channel}
            onTest={slackApi.onTest}
            isTesting={slackApi.isTesting}
            isPending={slackApi.isPending}
          />
        </Protected>
      </FooterConfigItem>
    </ConfigItem>
  )
}
